/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./libs/utilites.js":
/*!**************************!*\
  !*** ./libs/utilites.js ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatMoney: () => (/* binding */ formatMoney),
/* harmony export */   getCookie: () => (/* binding */ getCookie),
/* harmony export */   getStyle: () => (/* binding */ getStyle),
/* harmony export */   htmlToElement: () => (/* binding */ htmlToElement),
/* harmony export */   randomStr: () => (/* binding */ randomStr),
/* harmony export */   setCookie: () => (/* binding */ setCookie)
/* harmony export */ });
/**
 *
 * @param html
 * @returns {HTMLElement}
 */
const htmlToElement = html => {
  const template = document.createElement("template");
  template.innerHTML = html.trim();
  return template.content.firstChild;
};

/**
 *
 * @param e
 * @param t
 * @returns {string}
 */
const formatMoney = function (e, t) {
  function n(e, t) {
    return "undefined" == typeof e ? t : e;
  }
  function r(e, t, r, i) {
    if (t = n(t, 2), r = n(r, ","), i = n(i, "."), isNaN(e) || null == e) return 0;
    e = (e / 100).toFixed(t);
    var o = e.split("."),
      a = o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + r),
      s = o[1] ? i + o[1] : "";
    return a + s;
  }
  "string" == typeof e && (e = e.replace(".", ""));
  var i = "",
    o = /\{\{\s*(\w+)\s*\}\}/,
    a = t || this.money_format;
  switch (a.match(o)[1]) {
    case "amount":
      i = r(e, 2);
      break;
    case "amount_no_decimals":
      i = r(e, 0);
      break;
    case "amount_with_comma_separator":
      i = r(e, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      i = r(e, 0, ".", ",");
  }
  return a.replace(o, i);
};

/**
 *
 * @param name
 * @returns {any}
 */
function getCookie(name) {
  const prepareName = name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1');
  const matches = document.cookie.match(new RegExp(`(?:^|; )${prepareName}=([^;]*)`));
  return matches && typeof matches[1] !== 'undefined' ? decodeURIComponent(matches[1]) : null;
}

/**
 *
 * @param name
 * @param value
 * @param domain
 * @param expires
 */
function setCookie(name, value, domain = null, expires = 10000) {
  if (navigator.cookieEnabled) {
    const date = new Date();
    date.setDate(date.getDate() + expires);
    document.cookie = `${name}=${value};${domain !== null ? ' domain = ' + domain + ';' : ''} path=/; expires=${date.toUTCString()}`;
  }
}

/**
 *
 * @param length
 * @returns {string}
 */
const randomStr = length => {
  let result = "";
  let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

/**
 *
 * @param style
 * @returns {string}
 */
const getStyle = style => {
  return Object.entries(style).filter(([k, v]) => !!v).map(([k, v]) => `${k}:${v}`).join(';');
};

/***/ }),

/***/ "./components/CartBanner.ts":
/*!**********************************!*\
  !*** ./components/CartBanner.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CartBanner)
/* harmony export */ });
/* harmony import */ var _libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../libs/utilites.js */ "./libs/utilites.js");
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// @ts-ignore

class CartBanner {
  constructor() {
    var _this = this;
    _defineProperty(this, "render", function (el) {
      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'afterend';
      if (!el) return _this;
      //@ts-ignore
      el.insertAdjacentElement(position, _this.rootEl);
      el.remove();
      if (!_this.text) _this.hide();
      return _this;
    });
    _defineProperty(this, "show", () => {
      var _this$rootEl;
      (_this$rootEl = this.rootEl) === null || _this$rootEl === void 0 || _this$rootEl.classList.remove('els-cart-preview__banner--hide');
      if (!this.text) this.hide();
      return this;
    });
    _defineProperty(this, "hide", () => {
      var _this$rootEl2;
      (_this$rootEl2 = this.rootEl) === null || _this$rootEl2 === void 0 || _this$rootEl2.classList.add('els-cart-preview__banner--hide');
      return this;
    });
    _defineProperty(this, "template", () => {
      return "\n      <div class=\"els-cart-preview__banner\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10\" height=\"10\" viewBox=\"0 0 10 10\" fill=\"none\">\n          <circle cx=\"5\" cy=\"5\" r=\"5\" fill=\"#33DAFD\" fill-opacity=\"0.5\"/>\n          <circle cx=\"5\" cy=\"5\" r=\"3\" fill=\"#33DAFD\"/>\n        </svg>\n        <p>".concat(this.text, "<p>\n      </div>\n    ");
    });
  }
  //@ts-ignore

  //@ts-ignore

  init(text) {
    this.text = text;
    this.rootEl = (0,_libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__.htmlToElement)(this.template());
    return this;
  }
}

/***/ }),

/***/ "./components/CartFreeGiftProgressBar.ts":
/*!***********************************************!*\
  !*** ./components/CartFreeGiftProgressBar.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CartFreeGiftProgressBar)
/* harmony export */ });
/* harmony import */ var _libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../libs/utilites.js */ "./libs/utilites.js");
/* harmony import */ var _src_Helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../src/Helper */ "./src/Helper.ts");
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// @ts-ignore


class CartFreeGiftProgressBar {
  constructor() {
    var _this = this;
    // @ts-ignore
    // @ts-ignore
    _defineProperty(this, "cartTotal", 0);
    // @ts-ignore
    _defineProperty(this, "isShowing", true);
    _defineProperty(this, "render", function (el) {
      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'afterend';
      //@ts-ignore
      el === null || el === void 0 || el.insertAdjacentElement(position, _this.rootEl);
      el === null || el === void 0 || el.remove();
      return _this;
    });
    _defineProperty(this, "reRender", (cartTotal, isGiftAdded) => {
      var el = this.rootEl;
      this.init(cartTotal, isGiftAdded).render(el);
    });
    _defineProperty(this, "template", () => {
      return this.isShowing ? "<div class=\"els-cart-preview__progress-bar\">\n      <div class=\"els-cart-preview__progress-bar-title\">\n         <p>".concat(_src_Helper__WEBPACK_IMPORTED_MODULE_1__.Helper.FREE_GIFT_PROGRESS_BAR_TEXT.replace('{{amount}}', "".concat((0,_libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(Math.abs(this.cartTotal - _src_Helper__WEBPACK_IMPORTED_MODULE_1__.Helper.CART_TOTAL_PRICE_FOR_GIFTS) * 100, _src_Helper__WEBPACK_IMPORTED_MODULE_1__.Helper.MONEY_FORMAT))), "</p>\n         <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\">\n          <mask id=\"mask0_732_941\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"20\" height=\"20\">\n            <rect width=\"20\" height=\"20\" fill=\"#D9D9D9\"/>\n          </mask>\n          <g mask=\"url(#mask0_732_941)\">\n            <path d=\"M3.42952 16.4098V8.84569H3.34937C2.99789 8.84569 2.69902 8.72256 2.45277 8.47631C2.20651 8.23006 2.08337 7.93119 2.08337 7.57969V5.76879C2.08337 5.41731 2.20651 5.11843 2.45277 4.87217C2.69902 4.62592 2.99789 4.50279 3.34937 4.50279H6.39269C6.27516 4.36711 6.19529 4.21431 6.15308 4.0444C6.11089 3.87449 6.08979 3.69609 6.08979 3.50919C6.08979 2.88598 6.30792 2.35625 6.74417 1.92C7.18042 1.48375 7.71015 1.26562 8.33335 1.26562C8.6528 1.26562 8.94874 1.33267 9.22117 1.46675C9.49361 1.60083 9.7372 1.78006 9.95194 2.00442C10.1667 1.7715 10.4103 1.59014 10.6827 1.46033C10.9551 1.33053 11.2511 1.26562 11.5705 1.26562C12.1937 1.26562 12.7235 1.48375 13.1597 1.92C13.596 2.35625 13.8141 2.88598 13.8141 3.50919C13.8141 3.69402 13.7909 3.86977 13.7444 4.03644C13.6979 4.2031 13.6202 4.35856 13.5112 4.50279H16.6507C17.0022 4.50279 17.301 4.62592 17.5473 4.87217C17.7935 5.11843 17.9167 5.41731 17.9167 5.76879V7.57969C17.9167 7.93119 17.7935 8.23006 17.5473 8.47631C17.301 8.72256 17.0022 8.84569 16.6507 8.84569H16.5705V16.4098C16.5705 16.8241 16.423 17.1787 16.128 17.4737C15.833 17.7687 15.4784 17.9162 15.0641 17.9162H4.93592C4.52165 17.9162 4.16702 17.7687 3.87202 17.4737C3.57702 17.1787 3.42952 16.8241 3.42952 16.4098ZM11.5705 2.51558C11.289 2.51558 11.053 2.61081 10.8626 2.80125C10.6721 2.9917 10.5769 3.22767 10.5769 3.50919C10.5769 3.79071 10.6721 4.02669 10.8626 4.21713C11.053 4.40757 11.289 4.50279 11.5705 4.50279C11.852 4.50279 12.088 4.40757 12.2785 4.21713C12.4689 4.02669 12.5641 3.79071 12.5641 3.50919C12.5641 3.22767 12.4689 2.9917 12.2785 2.80125C12.088 2.61081 11.852 2.51558 11.5705 2.51558ZM7.33975 3.50919C7.33975 3.79071 7.43497 4.02669 7.62542 4.21713C7.81586 4.40757 8.05184 4.50279 8.33335 4.50279C8.61487 4.50279 8.85085 4.40757 9.04129 4.21713C9.23174 4.02669 9.32696 3.79071 9.32696 3.50919C9.32696 3.22767 9.23174 2.9917 9.04129 2.80125C8.85085 2.61081 8.61487 2.51558 8.33335 2.51558C8.05184 2.51558 7.81586 2.61081 7.62542 2.80125C7.43497 2.9917 7.33975 3.22767 7.33975 3.50919ZM3.33335 5.75277V7.59573H9.37504V5.75277H3.33335ZM9.37504 16.6662V8.84569H4.67948V16.4098C4.67948 16.4846 4.70352 16.546 4.7516 16.5941C4.79969 16.6422 4.86112 16.6662 4.93592 16.6662H9.37504ZM10.625 16.6662H15.0641C15.1389 16.6662 15.2004 16.6422 15.2484 16.5941C15.2965 16.546 15.3206 16.4846 15.3206 16.4098V8.84569H10.625V16.6662ZM16.6667 7.59573V5.75277H10.625V7.59573H16.6667Z\" fill=\"white\"/>\n          </g>\n        </svg>\n      </div>\n      <div class=\"els-cart-preview__progress-bar-bar\">\n        <div class=\"els-cart-preview__progress-bar-value\" style=\"width: ").concat(Math.min(100, Math.round(+this.cartTotal / _src_Helper__WEBPACK_IMPORTED_MODULE_1__.Helper.CART_TOTAL_PRICE_FOR_GIFTS * 100)), "%\"></div>\n      </div>\n    <div>") : '<div data-cart-title></div>';
    });
  }
  init(cartTotal) {
    var isShow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    this.cartTotal = cartTotal;
    this.isShowing = isShow && this.cartTotal > 0 && this.cartTotal < _src_Helper__WEBPACK_IMPORTED_MODULE_1__.Helper.CART_TOTAL_PRICE_FOR_GIFTS;
    this.rootEl = (0,_libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__.htmlToElement)(this.template());
    return this;
  }
}

/***/ }),

/***/ "./components/CartGifts.ts":
/*!*********************************!*\
  !*** ./components/CartGifts.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CartGifts)
/* harmony export */ });
/* harmony import */ var _libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../libs/utilites.js */ "./libs/utilites.js");
/* harmony import */ var _CartUpselItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CartUpselItem */ "./components/CartUpselItem.ts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// @ts-ignore


class CartGifts {
  constructor() {
    var _this = this;
    //@ts-ignore
    //@ts-ignore
    //@ts-ignore
    //@ts-ignore
    //@ts-ignore
    //@ts-ignore
    //@ts-ignore
    //@ts-ignore
    _defineProperty(this, "isShowBorderTop", false);
    _defineProperty(this, "render", function (el) {
      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'afterend';
      if (!el) return _this;
      //@ts-ignore
      el.insertAdjacentElement(position, _this.rootEl);
      el.remove();
      if (_this.listEl) {
        setTimeout(() => {
          var listEl = document.querySelector('.els-cart-preview__gifts [data-list]');
          //@ts-ignore
          _this.flickity = new Flickity(listEl, {
            cellAlign: 'left',
            prevNextButtons: false,
            pageDots: false
          });
        }, 100);
      }
      return _this;
    });
    _defineProperty(this, "reRender", function (items) {
      var isShowBorderTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var el = _this.rootEl;
      _this.isShowBorderTop = isShowBorderTop;
      _this.init(items).render(el);
      return _this;
    });
    _defineProperty(this, "addEventListeners", () => {
      var _this$nextBtn, _this$prevBtn;
      //@ts-ignore
      (_this$nextBtn = this.nextBtn) === null || _this$nextBtn === void 0 || _this$nextBtn.addEventListener('click', () => this.flickity.next(true, false));
      //@ts-ignore
      (_this$prevBtn = this.prevBtn) === null || _this$prevBtn === void 0 || _this$prevBtn.addEventListener('click', () => this.flickity.previous(true, false));
    });
    _defineProperty(this, "template", () => {
      var _this$items;
      return ((_this$items = this.items) === null || _this$items === void 0 ? void 0 : _this$items.length) > 0 ? "\n      <div class=\"els-cart-preview__gifts ".concat(this.isShowBorderTop ? 'els-cart-preview__gifts-with-border-top' : '', "\">\n        <div class=\"els-cart-preview__gifts-head\">\n          <p class=\"els-cart-preview__gifts-title\">Select Your Free Gift</p>\n          <div class=\"els-cart-preview__gifts-btns\">\n            <button class=\"els-cart-preview__gifts-btn\" data-prev>\n              <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"30\" height=\"30\" viewBox=\"0 0 30 30\" fill=\"none\">\n                <mask id=\"mask0_329_3585\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"30\" height=\"30\">\n                  <rect width=\"30\" height=\"30\" fill=\"#D9D9D9\"/>\n                </mask>\n                <g mask=\"url(#mask0_329_3585)\">\n                  <path d=\"M8.98306 15.9381L13.0985 20.0535C13.2844 20.2394 13.3761 20.457 13.3737 20.7062C13.3713 20.9554 13.2795 21.1769 13.0985 21.3708C12.9046 21.5647 12.6818 21.6649 12.4302 21.6713C12.1786 21.6777 11.9559 21.584 11.762 21.39L6.1634 15.7915C5.93744 15.5655 5.82446 15.3019 5.82446 15.0006C5.82446 14.6994 5.93744 14.4358 6.1634 14.2098L11.762 8.61123C11.9479 8.42534 12.1686 8.33359 12.4242 8.33598C12.6798 8.3384 12.9046 8.43656 13.0985 8.63045C13.2795 8.82437 13.3733 9.04392 13.3797 9.28911C13.3861 9.5343 13.2924 9.75384 13.0985 9.94773L8.98306 14.0632H23.6898C23.9559 14.0632 24.1786 14.1529 24.3581 14.3324C24.5376 14.5119 24.6273 14.7346 24.6273 15.0006C24.6273 15.2667 24.5376 15.4894 24.3581 15.6689C24.1786 15.8484 23.9559 15.9381 23.6898 15.9381H8.98306Z\" fill=\"white\"/>\n                </g>\n              </svg>\n            </button>\n            <button class=\"els-cart-preview__gifts-btn\" data-next>\n              <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"30\" height=\"30\" viewBox=\"0 0 30 30\" fill=\"none\">\n                <mask id=\"mask0_329_3582\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"30\" height=\"30\">\n                  <rect width=\"30\" height=\"30\" fill=\"#D9D9D9\"/>\n                </mask>\n                <g mask=\"url(#mask0_329_3582)\">\n                  <path d=\"M20.7644 15.9366H6.5625C6.29648 15.9366 6.07373 15.8468 5.89425 15.6673C5.71475 15.4879 5.625 15.2651 5.625 14.9991C5.625 14.7331 5.71475 14.5103 5.89425 14.3308C6.07373 14.1514 6.29648 14.0616 6.5625 14.0616H20.7644L16.649 9.94618C16.4631 9.76029 16.3714 9.54274 16.3738 9.29356C16.3762 9.04437 16.4679 8.82282 16.649 8.6289C16.8429 8.43501 17.0657 8.33485 17.3173 8.32843C17.5689 8.32202 17.7916 8.41577 17.9855 8.60968L23.5841 14.2082C23.701 14.3252 23.7836 14.4486 23.8317 14.5784C23.8797 14.7082 23.9038 14.8484 23.9038 14.9991C23.9038 15.1497 23.8797 15.29 23.8317 15.4197C23.7836 15.5496 23.701 15.673 23.5841 15.7899L17.9855 21.3885C17.7996 21.5744 17.5789 21.6661 17.3233 21.6637C17.0677 21.6613 16.8429 21.5632 16.649 21.3693C16.4679 21.1754 16.3742 20.9558 16.3677 20.7106C16.3614 20.4654 16.4551 20.2459 16.649 20.052L20.7644 15.9366Z\" fill=\"white\"/>\n                </g>\n              </svg>\n            </button>\n          </div>\n        </div>\n        <div class=\"els-cart-preview__gifts-list1\" data-list></div>\n      </div>\n    ") : '<div data-cart-gifts></div>';
    });
  }
  init(items) {
    var onAdd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.onAdd;
    this.onAdd = onAdd;
    this.items = items.map(item => new _CartUpselItem__WEBPACK_IMPORTED_MODULE_1__["default"]().init(_objectSpread(_objectSpread({}, item), {}, {
      isGift: true
    }), onAdd));
    this.rootEl = (0,_libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__.htmlToElement)(this.template());
    //@ts-ignore
    this.listEl = this.rootEl.querySelector('[data-list]');
    if (this.listEl) {
      this.items.map(item => item.render(this.listEl));
    }
    //@ts-ignore
    this.nextBtn = this.rootEl.querySelector('[data-next]');
    //@ts-ignore
    this.prevBtn = this.rootEl.querySelector('[data-prev]');
    this.addEventListeners();
    return this;
  }
}

/***/ }),

/***/ "./components/CartItem.ts":
/*!********************************!*\
  !*** ./components/CartItem.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CartItem)
/* harmony export */ });
/* harmony import */ var _libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../libs/utilites.js */ "./libs/utilites.js");
/* harmony import */ var _src_Helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../src/Helper */ "./src/Helper.ts");
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// @ts-ignore


class CartItem {
  constructor() {
    var _this = this;
    _defineProperty(this, "render", function (el) {
      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'beforeend';
      if (!el) return;
      //@ts-ignore
      el.insertAdjacentElement(position, _this.rootEl);
    });
    _defineProperty(this, "addEventListeners", () => {
      var _this$plusBtns, _this$minusBtns, _this$deleteBtn, _this$qtyInputs;
      //@ts-ignore
      (_this$plusBtns = this.plusBtns) === null || _this$plusBtns === void 0 || _this$plusBtns.forEach(plusBtn => {
        plusBtn.addEventListener('click', () => {
          //@ts-ignore
          this.onQtyChange(this.item.key, +this.qtyInputs[0].value + 1);
        });
      });
      //@ts-ignore
      (_this$minusBtns = this.minusBtns) === null || _this$minusBtns === void 0 || _this$minusBtns.forEach(minusBtn => {
        minusBtn.addEventListener('click', () => {
          //@ts-ignore
          this.onQtyChange(this.item.key, +this.qtyInputs[0].value - 1);
        });
      });
      //@ts-ignore
      (_this$deleteBtn = this.deleteBtn) === null || _this$deleteBtn === void 0 || _this$deleteBtn.addEventListener('click', () => this.onDelete(this.item.key));
      //@ts-ignore
      (_this$qtyInputs = this.qtyInputs) === null || _this$qtyInputs === void 0 || _this$qtyInputs.forEach(qtyInput => {
        //@ts-ignore
        qtyInput === null || qtyInput === void 0 || qtyInput.addEventListener('change', () => this.onQtyChange(this.item.key, +qtyInput.value));
      });
    });
    _defineProperty(this, "getPrice", () => {
      var _this$item3;
      if (this.item.compare_at_price) {
        var _this$item, _this$item2;
        return {
          price: (_this$item = this.item) === null || _this$item === void 0 ? void 0 : _this$item.price,
          compare_at_price: (_this$item2 = this.item) === null || _this$item2 === void 0 ? void 0 : _this$item2.compare_at_price
        };
      }
      return {
        price: (_this$item3 = this.item) === null || _this$item3 === void 0 ? void 0 : _this$item3.price
      };
    });
    _defineProperty(this, "getSellingPlanName", () => {
      var _this$item$selling_pl, _this$item4;
      return (_this$item$selling_pl = (_this$item4 = this.item) === null || _this$item4 === void 0 || (_this$item4 = _this$item4.selling_plan_allocation) === null || _this$item4 === void 0 || (_this$item4 = _this$item4.selling_plan) === null || _this$item4 === void 0 ? void 0 : _this$item4.name) !== null && _this$item$selling_pl !== void 0 ? _this$item$selling_pl : null;
    });
    _defineProperty(this, "getSellingPlanDiscount", () => {
      var _this$item5, _this$item6;
      var price = (_this$item5 = this.item) !== null && _this$item5 !== void 0 && (_this$item5 = _this$item5.selling_plan_allocation) !== null && _this$item5 !== void 0 && (_this$item5 = _this$item5.selling_plan) !== null && _this$item5 !== void 0 && _this$item5.price_adjustments ? (_this$item6 = this.item) === null || _this$item6 === void 0 || (_this$item6 = _this$item6.selling_plan_allocation) === null || _this$item6 === void 0 || (_this$item6 = _this$item6.selling_plan) === null || _this$item6 === void 0 ? void 0 : _this$item6.price_adjustments[0] : null;
      return price ? (price === null || price === void 0 ? void 0 : price.value_type) === 'percentage' ? "".concat(price.value, "%") : (0,_libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(price.value, _src_Helper__WEBPACK_IMPORTED_MODULE_1__.Helper.MONEY_FORMAT) : null;
    });
    _defineProperty(this, "getQtyInput", () => {
      return "\n    <div class=\"els-cart-preview__item-qty\">          \n      ".concat(!this.item.isGift ? "\n      <div class=\"els-cart-preview__item-qty-input\">\n        <button class=\"els-cart-preview__item-qty-input-btn\" data-minus>-</button>\n        <input type=\"number\" min=\"1\" value=\"".concat(this.item.quantity, "\" data-qty-input>\n        <button class=\"els-cart-preview__item-qty-input-btn\" data-plus>+</button>\n      </div>") : '', "                           \n      ").concat(this.getSellingPlanName() ? "<div class=\"els-cart-preview__item-sale-plan-badge\">".concat(this.getSellingPlanName(), "</div>") : '', "\n    </div>\n    ");
    });
    _defineProperty(this, "template", () => {
      var _this$item$properties;
      return "\n      <div class=\"els-cart-preview__item ".concat(this.item.isGift ? 'els-cart-preview__item--isGift' : '', "\">\n        <div class=\"els-cart-preview__item-info\">\n          <div class=\"els-cart-preview__item-image-box\">\n            ").concat(!!this.getPrice().compare_at_price && !this.getSellingPlanDiscount() && !((_this$item$properties = this.item.properties) !== null && _this$item$properties !== void 0 && _this$item$properties.gift) ? '<div class="els-cart-preview__item-badge sale-badge">Sale</div>' : '', "\n            <img src=\"").concat(this.item.image, "\">\n          </div>\n          <div class=\"els-cart-preview__item-content\">\n            <div class=\"els-cart-preview__item-title\">\n              <a href=\"").concat(this.item.url, "\">").concat(this.item.title, "</a>\n              <button class=\"els-cart-preview__item-remove\" data-delete-btn>\n                <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"16\" viewBox=\"0 0 14 16\" fill=\"none\">\n                  <path d=\"M2.61537 15.9997C2.17114 15.9997 1.79086 15.8415 1.47452 15.5252C1.15817 15.2089 1 14.8286 1 14.3843V1.99972H0.5C0.358333 1.99972 0.239583 1.95174 0.14375 1.85577C0.0479167 1.7598 0 1.64089 0 1.49904C0 1.35718 0.0479167 1.23849 0.14375 1.14299C0.239583 1.04748 0.358333 0.999719 0.5 0.999719H4C4 0.793303 4.0766 0.613494 4.2298 0.460294C4.38302 0.307077 4.56283 0.230469 4.76923 0.230469H9.23078C9.43718 0.230469 9.61698 0.307077 9.7702 0.460294C9.9234 0.613494 10 0.793303 10 0.999719H13.5C13.6417 0.999719 13.7604 1.0477 13.8562 1.14367C13.9521 1.23962 14 1.35853 14 1.50039C14 1.64224 13.9521 1.76093 13.8562 1.85644C13.7604 1.95196 13.6417 1.99972 13.5 1.99972H13V14.3843C13 14.8286 12.8418 15.2089 12.5255 15.5252C12.2091 15.8415 11.8289 15.9997 11.3846 15.9997H2.61537ZM12 1.99972H2V14.3843C2 14.5638 2.05769 14.7113 2.17308 14.8266C2.28846 14.942 2.43589 14.9997 2.61537 14.9997H11.3846C11.5641 14.9997 11.7115 14.942 11.8269 14.8266C11.9423 14.7113 12 14.5638 12 14.3843V1.99972ZM5.30837 12.9997C5.45022 12.9997 5.56891 12.9518 5.66442 12.856C5.75994 12.7601 5.8077 12.6414 5.8077 12.4997V4.49972C5.8077 4.35805 5.75972 4.2393 5.66375 4.14347C5.56778 4.04764 5.44888 3.99972 5.30703 3.99972C5.16516 3.99972 5.04647 4.04764 4.95095 4.14347C4.85543 4.2393 4.80768 4.35805 4.80768 4.49972V12.4997C4.80768 12.6414 4.85566 12.7601 4.95163 12.856C5.04759 12.9518 5.16651 12.9997 5.30837 12.9997ZM8.69298 12.9997C8.83484 12.9997 8.95353 12.9518 9.04905 12.856C9.14457 12.7601 9.19232 12.6414 9.19232 12.4997V4.49972C9.19232 4.35805 9.14434 4.2393 9.04838 4.14347C8.95241 4.04764 8.83349 3.99972 8.69162 3.99972C8.54977 3.99972 8.43109 4.04764 8.33557 4.14347C8.24006 4.2393 8.1923 4.35805 8.1923 4.49972V12.4997C8.1923 12.6414 8.24028 12.7601 8.33625 12.856C8.43222 12.9518 8.55112 12.9997 8.69298 12.9997Z\" fill=\"white\" fill-opacity=\"1\"/>\n                </svg>\n              </button>\n            </div>\n            <div class=\"els-cart-preview-price\">\n               ").concat(
      //@ts-ignore
      !!this.getPrice().compare_at_price && this.getPrice().compare_at_price > this.getPrice().price ? "<p class=\"els-cart-preview-price__old-price\">".concat((0,_libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(this.getPrice().compare_at_price, _src_Helper__WEBPACK_IMPORTED_MODULE_1__.Helper.MONEY_FORMAT), "</p>") : '', "\n              <p class=\"els-cart-preview-price__price\">").concat(!this.item.isGift ? (0,_libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(this.getPrice().price, _src_Helper__WEBPACK_IMPORTED_MODULE_1__.Helper.MONEY_FORMAT) : "<span class=\"els-cart-preview__item-free-gift\">\n                 <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"13\" height=\"14\" viewBox=\"0 0 13 14\" fill=\"none\">\n                    <path d=\"M1.57211 12.3073V6.63427H1.512C1.24839 6.63427 1.02423 6.54192 0.839547 6.35723C0.654849 6.17255 0.5625 5.94839 0.5625 5.68477V4.32659C0.5625 4.06298 0.654849 3.83882 0.839547 3.65413C1.02423 3.46944 1.24839 3.37709 1.512 3.37709H3.79448C3.70634 3.27533 3.64644 3.16073 3.61478 3.0333C3.58314 2.90587 3.56731 2.77207 3.56731 2.63189C3.56731 2.16448 3.73091 1.76719 4.05809 1.44C4.38528 1.11281 4.78258 0.949219 5.24998 0.949219C5.48957 0.949219 5.71152 0.9995 5.91584 1.10006C6.12018 1.20062 6.30287 1.33504 6.46392 1.50331C6.62498 1.32862 6.80768 1.1926 7.012 1.09525C7.21632 0.997896 7.43828 0.949219 7.67786 0.949219C8.14528 0.949219 8.54258 1.11281 8.86977 1.44C9.19695 1.76719 9.36055 2.16448 9.36055 2.63189C9.36055 2.77052 9.34312 2.90233 9.30825 3.02733C9.2734 3.15233 9.21511 3.26892 9.13338 3.37709H11.488C11.7516 3.37709 11.9757 3.46944 12.1604 3.65413C12.3451 3.83882 12.4375 4.06298 12.4375 4.32659V5.68477C12.4375 5.94839 12.3451 6.17255 12.1604 6.35723C11.9757 6.54192 11.7516 6.63427 11.488 6.63427H11.4279V12.3073C11.4279 12.618 11.3172 12.884 11.096 13.1053C10.8747 13.3265 10.6088 13.4372 10.2981 13.4372H2.70191C2.39121 13.4372 2.12523 13.3265 1.90398 13.1053C1.68273 12.884 1.57211 12.618 1.57211 12.3073ZM7.67786 1.88669C7.46672 1.88669 7.28974 1.9581 7.14691 2.10094C7.00407 2.24377 6.93266 2.42075 6.93266 2.63189C6.93266 2.84304 7.00407 3.02002 7.14691 3.16284C7.28974 3.30568 7.46672 3.37709 7.67786 3.37709C7.88901 3.37709 8.06599 3.30568 8.20881 3.16284C8.35165 3.02002 8.42306 2.84304 8.42306 2.63189C8.42306 2.42075 8.35165 2.24377 8.20881 2.10094C8.06599 1.9581 7.88901 1.88669 7.67786 1.88669ZM4.50478 2.63189C4.50478 2.84304 4.5762 3.02002 4.71903 3.16284C4.86187 3.30568 5.03885 3.37709 5.24998 3.37709C5.46112 3.37709 5.6381 3.30568 5.78094 3.16284C5.92377 3.02002 5.99519 2.84304 5.99519 2.63189C5.99519 2.42075 5.92377 2.24377 5.78094 2.10094C5.6381 1.9581 5.46112 1.88669 5.24998 1.88669C5.03885 1.88669 4.86187 1.9581 4.71903 2.10094C4.5762 2.24377 4.50478 2.42075 4.50478 2.63189ZM1.49998 4.31458V5.6968H6.03125V4.31458H1.49998ZM6.03125 12.4997V6.63427H2.50958V12.3073C2.50958 12.3634 2.52761 12.4095 2.56367 12.4456C2.59973 12.4816 2.64581 12.4997 2.70191 12.4997H6.03125ZM6.96872 12.4997H10.2981C10.3542 12.4997 10.4002 12.4816 10.4363 12.4456C10.4724 12.4095 10.4904 12.3634 10.4904 12.3073V6.63427H6.96872V12.4997ZM11.5 5.6968V4.31458H6.96872V5.6968H11.5Z\" fill=\"white\"/>\n                  </svg>\n                <span>Free Gift</span></span>", "\n              </p>\n              ").concat(
      //@ts-ignore
      this.getSellingPlanDiscount() && this.getPrice().compare_at_price > this.getPrice().price ? "<p class=\"els-cart-preview-saving-text\">".concat(this.getSellingPlanDiscount(), " Off</p>") : '', "\n            </div>\n            ").concat(this.getQtyInput(), "\n          </div>\n        </div>\n        ").concat(this.getQtyInput(), "\n      </div>\n    ");
    });
  }
  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  init(item, onDelete, onQtyChange) {
    this.item = item;
    this.onDelete = onDelete;
    this.onQtyChange = onQtyChange;
    this.rootEl = (0,_libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__.htmlToElement)(this.template());
    //@ts-ignore
    this.deleteBtn = this.rootEl.querySelector('[data-delete-btn]');
    //@ts-ignore
    this.plusBtns = this.rootEl.querySelectorAll('[data-plus]');
    //@ts-ignore
    this.minusBtns = this.rootEl.querySelectorAll('[data-minus]');
    //@ts-ignore
    this.qtyInputs = this.rootEl.querySelectorAll('[data-qty-input]');
    this.addEventListeners();
    return this;
  }
}

/***/ }),

/***/ "./components/CartPreview.ts":
/*!***********************************!*\
  !*** ./components/CartPreview.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CartPreview)
/* harmony export */ });
/* harmony import */ var _libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../libs/utilites.js */ "./libs/utilites.js");
/* harmony import */ var _libs_Cart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../libs/Cart */ "./libs/Cart.ts");
/* harmony import */ var _src_Helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../src/Helper */ "./src/Helper.ts");
/* harmony import */ var _CartItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CartItem */ "./components/CartItem.ts");
/* harmony import */ var _CartStatusBlock__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./CartStatusBlock */ "./components/CartStatusBlock.ts");
/* harmony import */ var _CartBanner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./CartBanner */ "./components/CartBanner.ts");
/* harmony import */ var _CartSubtotal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./CartSubtotal */ "./components/CartSubtotal.ts");
/* harmony import */ var _CartRecommendedItems__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./CartRecommendedItems */ "./components/CartRecommendedItems.ts");
/* harmony import */ var _CartGifts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./CartGifts */ "./components/CartGifts.ts");
/* harmony import */ var _CartTitle__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./CartTitle */ "./components/CartTitle.ts");
/* harmony import */ var _CartFreeGiftProgressBar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./CartFreeGiftProgressBar */ "./components/CartFreeGiftProgressBar.ts");
/* harmony import */ var _CartScrollDownButton__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./CartScrollDownButton */ "./components/CartScrollDownButton.ts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// @ts-ignore












class CartPreview {
  constructor() {
    var _this = this;
    //@ts-ignore
    _defineProperty(this, "isOpen", false);
    //@ts-ignore
    _defineProperty(this, "isProductAdded", false);
    /**
     *
     * @param position
     */
    _defineProperty(this, "render", function () {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'beforeend';
      //@ts-ignore
      document.body.insertAdjacentElement(position, _this.rootEl);
    });
    _defineProperty(this, "open", () => {
      var _this$cartEl, _this$overlay, _this$scrollDownButto;
      this.isOpen = true;
      document.body.classList.add('unscrollable');
      (_this$cartEl = this.cartEl) === null || _this$cartEl === void 0 || (_this$cartEl = _this$cartEl.classList) === null || _this$cartEl === void 0 || _this$cartEl.add('els-cart-preview--show');
      (_this$overlay = this.overlay) === null || _this$overlay === void 0 || (_this$overlay = _this$overlay.classList) === null || _this$overlay === void 0 || _this$overlay.add('els-cart-preview-overlay--show');
      (_this$scrollDownButto = this.scrollDownButton) === null || _this$scrollDownButto === void 0 || _this$scrollDownButto.reRender();
    });
    _defineProperty(this, "openAndProductAdded", () => {
      this.isProductAdded = true;
      this.updateCart().then(() => {
        this.open();
      });
    });
    _defineProperty(this, "close", () => {
      var _this$cartEl2, _this$overlay2;
      this.isOpen = false;
      this.isProductAdded = false;
      (_this$cartEl2 = this.cartEl) === null || _this$cartEl2 === void 0 || (_this$cartEl2 = _this$cartEl2.classList) === null || _this$cartEl2 === void 0 || _this$cartEl2.remove('els-cart-preview--show');
      (_this$overlay2 = this.overlay) === null || _this$overlay2 === void 0 || (_this$overlay2 = _this$overlay2.classList) === null || _this$overlay2 === void 0 || _this$overlay2.remove('els-cart-preview-overlay--show');
      document.body.classList.remove('unscrollable');
    });
    _defineProperty(this, "updateCart", () => {
      return new Promise(resolve => {
        this.cartApi.get().then(cart => {
          console.log('CART', cart);
          this.cart = cart;
          this.isProductAdded = this.isProductAdded && _src_Helper__WEBPACK_IMPORTED_MODULE_2__.Helper.PRODUCT_UPSELLS.length > 0;
          this.renderBlocks();
          this.checkAndRemoveGiftIfChangeTotalPrice();
          //@ts-ignore
          resolve();
        });
      });
    });
    _defineProperty(this, "checkAndRemoveGiftIfChangeTotalPrice", () => {
      var _this$cart;
      var cartGift = (_this$cart = this.cart) === null || _this$cart === void 0 || (_this$cart = _this$cart.items) === null || _this$cart === void 0 ? void 0 : _this$cart.find(item => {
        var _item$properties;
        return !!((_item$properties = item.properties) !== null && _item$properties !== void 0 && _item$properties.gift);
      });
      if (cartGift && this.cart.total_price / 100 < _src_Helper__WEBPACK_IMPORTED_MODULE_2__.Helper.CART_TOTAL_PRICE_FOR_GIFTS) {
        this.onItemDelete(cartGift.key);
        this.updateCart().then();
      }
    });
    _defineProperty(this, "renderBlocks", () => {
      var _this$subtotal, _this$cart2;
      this.renderItems();
      this.renderTitle();
      (_this$subtotal = this.subtotal) === null || _this$subtotal === void 0 || _this$subtotal.reRender(this.cart, !this.isProductAdded);
      this.updateRecommendedItems();
      this.updateCheckoutBtnText(this.isProductAdded ? 'View Cart' : !((_this$cart2 = this.cart) !== null && _this$cart2 !== void 0 && (_this$cart2 = _this$cart2.items) !== null && _this$cart2 !== void 0 && _this$cart2.length) ? 'Shop All Supplements' : 'Proceed to Checkout');
      this.renderGifts();
      this.renderFreeGiftsProgressBar();
      this.renderScrollDownButton();
    });
    _defineProperty(this, "renderScrollDownButton", () => {
      var _this$scrollDownButto2;
      (_this$scrollDownButto2 = this.scrollDownButton) === null || _this$scrollDownButto2 === void 0 || _this$scrollDownButto2.reRender();
    });
    _defineProperty(this, "renderGifts", () => {
      var _this$cart3, _this$cart4, _this$gifts;
      var isShowBorderTop = ((_this$cart3 = this.cart) === null || _this$cart3 === void 0 || (_this$cart3 = _this$cart3.items) === null || _this$cart3 === void 0 ? void 0 : _this$cart3.length) > 1;
      var isShow = !this.isProductAdded && this.cart.total_price / 100 >= _src_Helper__WEBPACK_IMPORTED_MODULE_2__.Helper.CART_TOTAL_PRICE_FOR_GIFTS && !((_this$cart4 = this.cart) !== null && _this$cart4 !== void 0 && (_this$cart4 = _this$cart4.items) !== null && _this$cart4 !== void 0 && _this$cart4.some(item => _src_Helper__WEBPACK_IMPORTED_MODULE_2__.Helper.GIFTS.some(gift => {
        var _item$properties2;
        return gift.variants[0].id === item.variant_id && !!((_item$properties2 = item.properties) !== null && _item$properties2 !== void 0 && _item$properties2.gift);
      })));
      (_this$gifts = this.gifts) === null || _this$gifts === void 0 || _this$gifts.reRender(isShow ? _src_Helper__WEBPACK_IMPORTED_MODULE_2__.Helper.GIFTS : [], isShowBorderTop);
    });
    _defineProperty(this, "renderFreeGiftsProgressBar", () => {
      var _this$cart5, _this$freeGiftProgres;
      var isShow = !!_src_Helper__WEBPACK_IMPORTED_MODULE_2__.Helper.GIFTS.length && !this.isProductAdded && !((_this$cart5 = this.cart) !== null && _this$cart5 !== void 0 && (_this$cart5 = _this$cart5.items) !== null && _this$cart5 !== void 0 && _this$cart5.some(item => _src_Helper__WEBPACK_IMPORTED_MODULE_2__.Helper.GIFTS.some(gift => {
        var _item$properties3;
        return gift.variants[0].id === item.variant_id && !!((_item$properties3 = item.properties) !== null && _item$properties3 !== void 0 && _item$properties3.gift);
      })));
      (_this$freeGiftProgres = this.freeGiftProgressBar) === null || _this$freeGiftProgres === void 0 || _this$freeGiftProgres.reRender(this.cart.total_price / 100, isShow);
    });
    _defineProperty(this, "renderTitle", () => {
      var _this$title, _this$cart6;
      (_this$title = this.title) === null || _this$title === void 0 || _this$title.reRender(((_this$cart6 = this.cart) === null || _this$cart6 === void 0 || (_this$cart6 = _this$cart6.items) === null || _this$cart6 === void 0 ? void 0 : _this$cart6.length) > 0 && !this.isProductAdded);
    });
    _defineProperty(this, "updateRecommendedItems", () => {
      var _this$cart7;
      if (!((_this$cart7 = this.cart) !== null && _this$cart7 !== void 0 && (_this$cart7 = _this$cart7.items) !== null && _this$cart7 !== void 0 && _this$cart7.length) || this.isProductAdded) {
        var _this$cart8;
        if (!((_this$cart8 = this.cart) !== null && _this$cart8 !== void 0 && (_this$cart8 = _this$cart8.items) !== null && _this$cart8 !== void 0 && _this$cart8.length)) {
          var _this$recommendedItem, _Helper$RECOMMENDED_I;
          (_this$recommendedItem = this.recommendedItems) === null || _this$recommendedItem === void 0 || _this$recommendedItem.reRender((_Helper$RECOMMENDED_I = _src_Helper__WEBPACK_IMPORTED_MODULE_2__.Helper.RECOMMENDED_ITEMS) !== null && _Helper$RECOMMENDED_I !== void 0 ? _Helper$RECOMMENDED_I : [], 'Items We Recommend', true);
        }
        if (this.isProductAdded) {
          var _this$recommendedItem2, _Helper$PRODUCT_UPSEL;
          (_this$recommendedItem2 = this.recommendedItems) === null || _this$recommendedItem2 === void 0 || _this$recommendedItem2.reRender(((_Helper$PRODUCT_UPSEL = _src_Helper__WEBPACK_IMPORTED_MODULE_2__.Helper.PRODUCT_UPSELLS) !== null && _Helper$PRODUCT_UPSEL !== void 0 ? _Helper$PRODUCT_UPSEL : []).map(item => {
            var _this$cart9;
            return _objectSpread(_objectSpread({}, item), {}, {
              isAdded: (_this$cart9 = this.cart) === null || _this$cart9 === void 0 || (_this$cart9 = _this$cart9.items) === null || _this$cart9 === void 0 ? void 0 : _this$cart9.some(cartItem => cartItem.variant_id === item.variants[0].id)
            });
          }), 'You Might Also Like');
        }
      } else {
        var _this$recommendedItem3;
        (_this$recommendedItem3 = this.recommendedItems) === null || _this$recommendedItem3 === void 0 || _this$recommendedItem3.reRender([], '');
      }
    });
    _defineProperty(this, "onItemAdd", (id, properties) => {
      this.cartApi.itemAdd(_objectSpread({
        id,
        quantity: 1
      }, properties ? {
        properties
      } : {})).then(() => this.updateCart());
    });
    _defineProperty(this, "onItemDelete", key => {
      this.cartApi.itemRemove(key).then(() => this.updateCart());
    });
    _defineProperty(this, "onItemQtyChange", (key, qty) => {
      this.cartApi.itemUpdateQty(key, qty).then(() => this.updateCart());
    });
    _defineProperty(this, "onCheckout", () => {
      var _this$cart10;
      if (this.isProductAdded) {
        this.isProductAdded = false;
        this.renderBlocks();
        return;
      }
      console.log('111110');
      if (!((_this$cart10 = this.cart) !== null && _this$cart10 !== void 0 && (_this$cart10 = _this$cart10.items) !== null && _this$cart10 !== void 0 && _this$cart10.length)) {
        console.log('11111');
        if (!!_src_Helper__WEBPACK_IMPORTED_MODULE_2__.Helper.CART_PREVIEW_LINK_BUTTON) {
          console.log('111112');
          window.location.replace(_src_Helper__WEBPACK_IMPORTED_MODULE_2__.Helper.CART_PREVIEW_LINK_BUTTON);
        } else {
          this.close();
        }
        return;
      }
      window.location.replace('/checkout');
    });
    _defineProperty(this, "updateCheckoutBtnText", text => {
      if (this.checkoutBtn) this.checkoutBtn.innerHTML = text;
    });
    _defineProperty(this, "template", () => {
      return "<div>\n        <div class=\"els-cart-preview-overlay ".concat(this.isOpen && 'els-cart-preview-overlay--show', "\" data-overlay></div>\n        <div class=\"els-cart-preview ").concat(this.isOpen && 'els-cart-preview--show', "\" data-cart>\n          <button class=\"els-cart-preview__close\" data-close-btn></button>\n          <div class=\"els-cart-preview__scroll-box\">                   \n            <div data-cart-title></div>\n            <div data-cart-banner></div>\n            <div class=\"els-cart-preview__items\"></div>\n            <div data-cart-recommended-items></div>\n            <div data-cart-gifts></div>\n            <div data-cart-scroll-down-button></div>\n          </div>           \n          <div data-cart-free-gift-progress-bar></div>\n          <div data-cart-subtotal></div>\n          <button class=\"els-cart-preview__button\" data-checkout-btn>Proceed to Checkout</button>\n        </div>\n      </div>\n    ");
    });
  }
  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  init() {
    var _this$cartEl3, _this$cartEl4, _this$cartEl5, _this$cartEl6, _this$cartEl7, _this$cartEl8, _this$cartEl9;
    this.rootEl = (0,_libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__.htmlToElement)(this.template());
    //@ts-ignore
    this.overlay = this.rootEl.querySelector('[data-overlay]');
    //@ts-ignore
    this.cartEl = this.rootEl.querySelector('[data-cart]');
    //@ts-ignore
    this.cartItemsEl = this.cartEl.querySelector('.els-cart-preview__items');
    //@ts-ignore
    this.closeBtn = this.cartEl.querySelector('[data-close-btn]');
    //@ts-ignore
    this.checkoutBtn = this.cartEl.querySelector('[data-checkout-btn]');
    //@ts-ignore
    this.banner = new _CartBanner__WEBPACK_IMPORTED_MODULE_5__["default"]().init(_src_Helper__WEBPACK_IMPORTED_MODULE_2__.Helper.BANNER_TEXT).render((_this$cartEl3 = this.cartEl) === null || _this$cartEl3 === void 0 ? void 0 : _this$cartEl3.querySelector("[data-cart-banner]")).hide();
    //@ts-ignore
    this.subtotal = new _CartSubtotal__WEBPACK_IMPORTED_MODULE_6__["default"]().init(this.cart).render((_this$cartEl4 = this.cartEl) === null || _this$cartEl4 === void 0 ? void 0 : _this$cartEl4.querySelector("[data-cart-subtotal]"));
    //@ts-ignore
    this.recommendedItems = new _CartRecommendedItems__WEBPACK_IMPORTED_MODULE_7__["default"]().init([], '', false, this.onItemAdd).render((_this$cartEl5 = this.cartEl) === null || _this$cartEl5 === void 0 ? void 0 : _this$cartEl5.querySelector("[data-cart-recommended-items]"));
    //@ts-ignore
    this.gifts = new _CartGifts__WEBPACK_IMPORTED_MODULE_8__["default"]().init([], id => this.onItemAdd(id, {
      gift: true
    })).render((_this$cartEl6 = this.cartEl) === null || _this$cartEl6 === void 0 ? void 0 : _this$cartEl6.querySelector("[data-cart-gifts]"));
    //@ts-ignore
    this.title = new _CartTitle__WEBPACK_IMPORTED_MODULE_9__["default"]().init().render((_this$cartEl7 = this.cartEl) === null || _this$cartEl7 === void 0 ? void 0 : _this$cartEl7.querySelector("[data-cart-title]"));
    //@ts-ignore
    this.scrollBox = this.rootEl.querySelector('.els-cart-preview__scroll-box');
    //@ts-ignore
    this.scrollDownButton = new _CartScrollDownButton__WEBPACK_IMPORTED_MODULE_11__["default"]().init(this.scrollBox).render((_this$cartEl8 = this.cartEl) === null || _this$cartEl8 === void 0 ? void 0 : _this$cartEl8.querySelector("[data-cart-scroll-down-button]"));
    //@ts-ignore
    this.freeGiftProgressBar = new _CartFreeGiftProgressBar__WEBPACK_IMPORTED_MODULE_10__["default"]().init(0, !!_src_Helper__WEBPACK_IMPORTED_MODULE_2__.Helper.GIFTS.length).render((_this$cartEl9 = this.cartEl) === null || _this$cartEl9 === void 0 ? void 0 : _this$cartEl9.querySelector("[data-cart-free-gift-progress-bar]"));
    this.addEventListeners();
    this.cartApi = new _libs_Cart__WEBPACK_IMPORTED_MODULE_1__["default"]();
    return new Promise(resolve => {
      this.updateCart().then(() => {
        return resolve(this);
      });
    });
  }
  renderItems() {
    var _this$cart$items;
    if (this.cartItemsEl) this.cartItemsEl.innerHTML = '';
    if ((_this$cart$items = this.cart.items) !== null && _this$cart$items !== void 0 && _this$cart$items.length && !this.isProductAdded) {
      var _this$banner;
      (_this$banner = this.banner) === null || _this$banner === void 0 || _this$banner.show();
      this.items = this.cart.items.sort((a, b) => {
        var _a$properties, _b$properties;
        return ((_a$properties = a.properties) !== null && _a$properties !== void 0 && _a$properties.gift ? 1 : 0) - ((_b$properties = b.properties) !== null && _b$properties !== void 0 && _b$properties.gift ? 1 : 0);
      }).map((item, index) => {
        var _item$properties4;
        return new _CartItem__WEBPACK_IMPORTED_MODULE_3__["default"]().init(_objectSpread(_objectSpread({}, item), {}, {
          isGift: !!((_item$properties4 = item.properties) !== null && _item$properties4 !== void 0 && _item$properties4.gift)
        }), this.onItemDelete, this.onItemQtyChange).render(this.cartItemsEl);
      });
    } else {
      var _this$banner2;
      (_this$banner2 = this.banner) === null || _this$banner2 === void 0 || _this$banner2.hide();
      if (this.isProductAdded) {
        var _Helper$PRODUCT;
        new _CartStatusBlock__WEBPACK_IMPORTED_MODULE_4__["default"]().init('Added to Cart!', (_Helper$PRODUCT = _src_Helper__WEBPACK_IMPORTED_MODULE_2__.Helper.PRODUCT) === null || _Helper$PRODUCT === void 0 ? void 0 : _Helper$PRODUCT.featured_image).render(this.cartItemsEl);
      } else {
        new _CartStatusBlock__WEBPACK_IMPORTED_MODULE_4__["default"]().init('Your Cart is Empty').render(this.cartItemsEl);
      }
    }
  }
  addEventListeners() {
    var _this$closeBtn, _this$checkoutBtn, _this$overlay3;
    //@ts-ignore
    (_this$closeBtn = this.closeBtn) === null || _this$closeBtn === void 0 || _this$closeBtn.addEventListener('click', () => this.close());
    (_this$checkoutBtn = this.checkoutBtn) === null || _this$checkoutBtn === void 0 || _this$checkoutBtn.addEventListener('click', () => {
      this.onCheckout();
    });
    //@ts-ignore
    (_this$overlay3 = this.overlay) === null || _this$overlay3 === void 0 || _this$overlay3.addEventListener('click', () => this.close());
    var openBtns = document.querySelectorAll('[data-els-cart-preview-open]');
    openBtns.forEach(btn => btn.addEventListener('click', e => {
      e.preventDefault();
      this.open();
    }));
  }
}

/***/ }),

/***/ "./components/CartRecommendedItems.ts":
/*!********************************************!*\
  !*** ./components/CartRecommendedItems.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CartRecommendedItems)
/* harmony export */ });
/* harmony import */ var _libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../libs/utilites.js */ "./libs/utilites.js");
/* harmony import */ var _CartUpselItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CartUpselItem */ "./components/CartUpselItem.ts");
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// @ts-ignore


class CartRecommendedItems {
  constructor() {
    var _this = this;
    //@ts-ignore
    _defineProperty(this, "isView", false);
    _defineProperty(this, "render", function (el) {
      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'afterend';
      if (!el) return _this;
      //@ts-ignore
      el.insertAdjacentElement(position, _this.rootEl);
      el.remove();
      return _this;
    });
    _defineProperty(this, "reRender", function (items, text) {
      var isView = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var el = _this.rootEl;
      _this.init(items, text, isView).render(el);
      return _this;
    });
    _defineProperty(this, "template", () => {
      var _this$items;
      return ((_this$items = this.items) === null || _this$items === void 0 ? void 0 : _this$items.length) > 0 ? "\n      <div class=\"els-cart-preview__recomended-items\">\n        <p class=\"els-cart-preview__recomended-items-title\">".concat(this.text, "</p>\n        <div class=\"els-cart-preview__recomended-items-list\" data-list></div>\n      </div>\n    ") : '<div data-cart-recomenden-items></div>';
    });
  }
  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  init(items, text) {
    var isView = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var onAdd = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.onAdd;
    this.isView = isView;
    this.text = text;
    this.onAdd = onAdd;
    this.items = items.map(item => new _CartUpselItem__WEBPACK_IMPORTED_MODULE_1__["default"]().init(item, onAdd, isView));
    this.rootEl = (0,_libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__.htmlToElement)(this.template());
    //@ts-ignore
    this.listEl = this.rootEl.querySelector('[data-list]');
    this.items.map(item => item.render(this.listEl));
    return this;
  }
}

/***/ }),

/***/ "./components/CartScrollDownButton.ts":
/*!********************************************!*\
  !*** ./components/CartScrollDownButton.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CartScrollDownButton)
/* harmony export */ });
/* harmony import */ var _libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../libs/utilites.js */ "./libs/utilites.js");
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// @ts-ignore

class CartScrollDownButton {
  constructor() {
    var _this = this;
    // @ts-ignore
    //@ts-ignore
    // @ts-ignore
    _defineProperty(this, "scrollValue", 0);
    // @ts-ignore
    _defineProperty(this, "scrollHeight", 0);
    // @ts-ignore
    _defineProperty(this, "clientHeight", 0);
    _defineProperty(this, "render", function (el) {
      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'afterend';
      //@ts-ignore
      el.insertAdjacentElement(position, _this.rootEl);
      el === null || el === void 0 || el.remove();
      return _this;
    });
    _defineProperty(this, "reRender", () => {
      // @ts-ignore
      var el = this.rootEl;
      this.rootEl = (0,_libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__.htmlToElement)(this.template());
      this.render(el);
      this.addEventListeners();
    });
    _defineProperty(this, "isShowing", () => {
      // @ts-ignore
      return !!(this.scrollBox && this.scrollBox.scrollHeight > this.scrollBox.clientHeight && this.scrollBox.scrollTop + 30 < this.scrollBox.scrollHeight - this.scrollBox.clientHeight);
    });
    _defineProperty(this, "addEventListeners", () => {
      if (this.rootEl) {
        // @ts-ignore
        this.rootEl.addEventListener('click', () => {
          // @ts-ignore
          this.scrollBox.scrollTop = this.scrollBox.scrollHeight;
          this.reRender();
        });
      }
    });
    // template = () => {
    //   return  `<div class="els-cart-preview__scroll-down-button">
    //      <span>⇣</span>
    //   <div>` ;
    // }
    _defineProperty(this, "template", () => {
      return this.isShowing() ? "<div class=\"els-cart-preview__scroll-down-button\">\n       <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\">\n        <mask id=\"mask0_748_3392\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"32\" height=\"32\">\n          <rect width=\"32\" height=\"32\" fill=\"#D9D9D9\"/>\n        </mask>\n        <g mask=\"url(#mask0_748_3392)\">\n          <path d=\"M15.9992 19.5487C15.8385 19.5487 15.689 19.523 15.5505 19.4717C15.4121 19.4205 15.2804 19.3324 15.1557 19.2076L9.16336 13.2153C8.97873 13.0307 8.88429 12.7987 8.88002 12.5192C8.87573 12.2397 8.97018 12.0034 9.16336 11.8102C9.35651 11.6171 9.59069 11.5205 9.86589 11.5205C10.1411 11.5205 10.3753 11.6171 10.5684 11.8102L15.9992 17.241L21.43 11.8102C21.6146 11.6256 21.8467 11.5312 22.1262 11.5269C22.4056 11.5226 22.6419 11.6171 22.8351 11.8102C23.0283 12.0034 23.1249 12.2376 23.1249 12.5128C23.1249 12.788 23.0283 13.0222 22.8351 13.2153L16.8428 19.2076C16.718 19.3324 16.5864 19.4205 16.4479 19.4717C16.3095 19.523 16.1599 19.5487 15.9992 19.5487Z\" fill=\"white\"/>\n        </g>\n      </svg>\n    <div>" : "<div data-cart-scroll-down-button></div>";
    });
  }
  // @ts-ignore
  init(scrollBox) {
    this.rootEl = (0,_libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__.htmlToElement)(this.template());
    // @ts-ignore
    this.scrollBox = scrollBox;
    // @ts-ignore
    this.addEventListeners();
    setInterval(() => {
      var _this$scrollBox, _this$scrollBox2, _this$scrollBox3;
      if (this.scrollValue !== ((_this$scrollBox = this.scrollBox) === null || _this$scrollBox === void 0 ? void 0 : _this$scrollBox.scrollTop) || this.scrollHeight !== ((_this$scrollBox2 = this.scrollBox) === null || _this$scrollBox2 === void 0 ? void 0 : _this$scrollBox2.scrollHeight) || this.clientHeight !== ((_this$scrollBox3 = this.scrollBox) === null || _this$scrollBox3 === void 0 ? void 0 : _this$scrollBox3.clientHeight)) {
        var _this$scrollBox4, _this$scrollBox5, _this$scrollBox6;
        this.scrollValue = (_this$scrollBox4 = this.scrollBox) === null || _this$scrollBox4 === void 0 ? void 0 : _this$scrollBox4.scrollTop;
        this.scrollHeight = (_this$scrollBox5 = this.scrollBox) === null || _this$scrollBox5 === void 0 ? void 0 : _this$scrollBox5.scrollHeight;
        this.clientHeight = (_this$scrollBox6 = this.scrollBox) === null || _this$scrollBox6 === void 0 ? void 0 : _this$scrollBox6.clientHeight;
        this.reRender();
      }
    }, 50);
    this.reRender();
    return this;
  }
}

/***/ }),

/***/ "./components/CartStatusBlock.ts":
/*!***************************************!*\
  !*** ./components/CartStatusBlock.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CartStatusBlock)
/* harmony export */ });
/* harmony import */ var _libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../libs/utilites.js */ "./libs/utilites.js");
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// @ts-ignore

class CartStatusBlock {
  constructor() {
    var _this = this;
    _defineProperty(this, "render", function (el) {
      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'beforeend';
      if (!el) return;
      //@ts-ignore
      el.insertAdjacentElement(position, _this.rootEl);
    });
    _defineProperty(this, "template", () => {
      return "\n      <div>\n        <div class=\"els-cart-preview__status-block-mobile\">          \n          <p class=\"els-cart-preview__status-block-mobile-title\">\n            <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\">\n              <path d=\"M10.2268 14.6836L7.32278 11.7796C7.1497 11.6065 6.93215 11.518 6.67011 11.514C6.40807 11.5099 6.1865 11.5985 6.00541 11.7796C5.82431 11.9607 5.73377 12.1803 5.73377 12.4383C5.73377 12.6963 5.82431 12.9158 6.00541 13.0969L9.43591 16.5274C9.66189 16.7534 9.92553 16.8664 10.2268 16.8664C10.5281 16.8664 10.7918 16.7534 11.0177 16.5274L17.9725 9.57268C18.1456 9.3996 18.2341 9.18205 18.2381 8.92001C18.2422 8.65797 18.1536 8.43641 17.9725 8.25531C17.7914 8.07422 17.5718 7.98367 17.3138 7.98367C17.0558 7.98367 16.8363 8.07422 16.6552 8.25531L10.2268 14.6836ZM12.0031 23.8765C10.3606 23.8765 8.81666 23.5648 7.3714 22.9414C5.92612 22.318 4.66894 21.4721 3.59985 20.4034C2.53073 19.3348 1.68436 18.0782 1.06071 16.6335C0.437067 15.1889 0.125244 13.6454 0.125244 12.0028C0.125244 10.3603 0.436931 8.81642 1.06031 7.37116C1.68368 5.92588 2.52967 4.66869 3.59828 3.5996C4.66691 2.53049 5.92355 1.68411 7.36818 1.06047C8.8128 0.436824 10.3564 0.125 11.9989 0.125C13.6414 0.125 15.1853 0.436688 16.6306 1.06006C18.0759 1.68344 19.333 2.52943 20.4021 3.59804C21.4712 4.66667 22.3176 5.92331 22.9413 7.36794C23.5649 8.81256 23.8767 10.3561 23.8767 11.9986C23.8767 13.6412 23.565 15.1851 22.9417 16.6303C22.3183 18.0756 21.4723 19.3328 20.4037 20.4019C19.3351 21.471 18.0784 22.3174 16.6338 22.941C15.1892 23.5647 13.6456 23.8765 12.0031 23.8765Z\" fill=\"white\"/>\n            </svg>\n            ".concat(this.title, "\n          </p>\n        </div> \n        <div class=\"els-cart-preview__status-block\">\n          <p class=\"els-cart-preview__status-block-title\">").concat(this.title, "</p>\n          ").concat(!this.image ? "\n          <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"145\" height=\"145\" viewBox=\"0 0 145 145\" fill=\"none\">\n            <circle cx=\"72.5\" cy=\"72.5\" r=\"72.5\" fill=\"#0F2F57\"/>\n            <mask id=\"mask0_357_5869\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"40\" y=\"42\" width=\"65\" height=\"65\">\n              <rect x=\"40\" y=\"42\" width=\"65\" height=\"65\" fill=\"#D9D9D9\"/>\n            </mask>\n            <g mask=\"url(#mask0_357_5869)\">\n              <path d=\"M62.22 99.1875C61.0776 99.1875 60.1149 98.796 59.332 98.013C58.5489 97.23 58.1574 96.2673 58.1574 95.125C58.1574 93.9826 58.5489 93.02 59.332 92.237C60.1149 91.454 61.0776 91.0625 62.22 91.0625C63.3623 91.0625 64.325 91.454 65.108 92.237C65.891 93.02 66.2825 93.9826 66.2825 95.125C66.2825 96.2673 65.891 97.23 65.108 98.013C64.325 98.796 63.3623 99.1875 62.22 99.1875ZM87.6366 99.1875C86.4943 99.1875 85.5316 98.796 84.7486 98.013C83.9656 97.23 83.5741 96.2673 83.5741 95.125C83.5741 93.9826 83.9656 93.02 84.7486 92.237C85.5316 91.454 86.4943 91.0625 87.6366 91.0625C88.779 91.0625 89.7417 91.454 90.5246 92.237C91.3077 93.02 91.6992 93.9826 91.6992 95.125C91.6992 96.2673 91.3077 97.23 90.5246 98.013C89.7417 98.796 88.779 99.1875 87.6366 99.1875ZM52.7408 51.4792H49.1991C48.8155 51.4792 48.4938 51.3492 48.2343 51.0893C47.9747 50.8294 47.845 50.5074 47.845 50.1232C47.845 49.739 47.9747 49.4175 48.2343 49.1589C48.4938 48.9002 48.8155 48.7708 49.1991 48.7708H53.0875C53.5196 48.7708 53.9127 48.8791 54.2668 49.0956C54.621 49.3121 54.8866 49.6187 55.0637 50.0157L65.5689 72.1041H83.5377C83.8502 72.1041 84.128 72.026 84.371 71.8698C84.6141 71.7135 84.8224 71.4965 84.996 71.2188L94.0845 54.8646C94.2061 54.6563 94.3678 54.4913 94.5697 54.3698C94.7717 54.2483 94.996 54.1875 95.2428 54.1875C95.7589 54.1875 96.1462 54.4106 96.4049 54.8568C96.6636 55.303 96.6662 55.7517 96.4127 56.2031L87.3033 72.6979C86.9109 73.3577 86.4007 73.875 85.7725 74.25C85.1443 74.625 84.4566 74.8125 83.7095 74.8125H64.3658L61.0742 80.8542C60.7964 81.2708 60.7877 81.7222 61.0481 82.2083C61.3085 82.6944 61.6991 82.9375 62.22 82.9375H90.345C90.7286 82.9375 91.0503 83.0674 91.3099 83.3273C91.5694 83.5872 91.6992 83.9093 91.6992 84.2935C91.6992 84.6777 91.5694 84.9992 91.3099 85.2578C91.0503 85.5165 90.7286 85.6459 90.345 85.6459H62.22C60.6401 85.6459 59.4587 84.9827 58.6757 83.6563C57.8927 82.3299 57.8762 80.9896 58.6262 79.6354L62.6991 72.375L52.7408 51.4792ZM74.9283 67.7292C74.4561 67.7292 74.0602 67.5694 73.7408 67.25C73.4214 66.9305 73.2617 66.5347 73.2617 66.0625C73.2617 65.5903 73.4214 65.1944 73.7408 64.875C74.0602 64.5555 74.4561 64.3958 74.9283 64.3958C75.4005 64.3958 75.7964 64.5555 76.1158 64.875C76.4352 65.1944 76.5949 65.5903 76.5949 66.0625C76.5949 66.5347 76.4352 66.9305 76.1158 67.25C75.7964 67.5694 75.4005 67.7292 74.9283 67.7292ZM74.9265 59.6042C74.5423 59.6042 74.2208 59.4744 73.9622 59.2148C73.7035 58.9553 73.5741 58.6337 73.5741 58.25V47.4167C73.5741 47.033 73.7041 46.7114 73.964 46.4518C74.2239 46.1923 74.5459 46.0625 74.9301 46.0625C75.3144 46.0625 75.6358 46.1923 75.8944 46.4518C76.1531 46.7114 76.2825 47.033 76.2825 47.4167V58.25C76.2825 58.6337 76.1525 58.9553 75.8926 59.2148C75.6327 59.4744 75.3107 59.6042 74.9265 59.6042Z\" fill=\"white\"/>\n            </g>\n          </svg>" : "\n          <div class=\"els-cart-preview__status-block-image\">\n            <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\">\n              <path d=\"M10.2268 14.6836L7.32278 11.7796C7.1497 11.6065 6.93215 11.518 6.67011 11.514C6.40807 11.5099 6.1865 11.5985 6.00541 11.7796C5.82431 11.9607 5.73377 12.1803 5.73377 12.4383C5.73377 12.6963 5.82431 12.9158 6.00541 13.0969L9.43591 16.5274C9.66189 16.7534 9.92553 16.8664 10.2268 16.8664C10.5281 16.8664 10.7918 16.7534 11.0177 16.5274L17.9725 9.57268C18.1456 9.3996 18.2341 9.18205 18.2381 8.92001C18.2422 8.65797 18.1536 8.43641 17.9725 8.25531C17.7914 8.07422 17.5718 7.98367 17.3138 7.98367C17.0558 7.98367 16.8363 8.07422 16.6552 8.25531L10.2268 14.6836ZM12.0031 23.8765C10.3606 23.8765 8.81666 23.5648 7.3714 22.9414C5.92612 22.318 4.66894 21.4721 3.59985 20.4034C2.53073 19.3348 1.68436 18.0782 1.06071 16.6335C0.437067 15.1889 0.125244 13.6454 0.125244 12.0028C0.125244 10.3603 0.436931 8.81642 1.06031 7.37116C1.68368 5.92588 2.52967 4.66869 3.59828 3.5996C4.66691 2.53049 5.92355 1.68411 7.36818 1.06047C8.8128 0.436824 10.3564 0.125 11.9989 0.125C13.6414 0.125 15.1853 0.436688 16.6306 1.06006C18.0759 1.68344 19.333 2.52943 20.4021 3.59804C21.4712 4.66667 22.3176 5.92331 22.9413 7.36794C23.5649 8.81256 23.8767 10.3561 23.8767 11.9986C23.8767 13.6412 23.565 15.1851 22.9417 16.6303C22.3183 18.0756 21.4723 19.3328 20.4037 20.4019C19.3351 21.471 18.0784 22.3174 16.6338 22.941C15.1892 23.5647 13.6456 23.8765 12.0031 23.8765Z\" fill=\"white\"/>\n            </svg>\n            <img src=\"".concat(this.image, "\">\n          </div>\n          "), "\n        </div>\n      </div>\n    ");
    });
  }
  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  init(title) {
    var image = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    this.image = image;
    this.title = title;
    this.rootEl = (0,_libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__.htmlToElement)(this.template());
    return this;
  }
}

/***/ }),

/***/ "./components/CartSubtotal.ts":
/*!************************************!*\
  !*** ./components/CartSubtotal.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CartSubtotal)
/* harmony export */ });
/* harmony import */ var _libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../libs/utilites.js */ "./libs/utilites.js");
/* harmony import */ var _src_Helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../src/Helper */ "./src/Helper.ts");
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// @ts-ignore


class CartSubtotal {
  constructor() {
    var _this = this;
    //@ts-ignore
    _defineProperty(this, "show", false);
    _defineProperty(this, "render", function (el) {
      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'afterend';
      if (!el || !_this.rootEl) return _this;
      //@ts-ignore
      el.insertAdjacentElement(position, _this.rootEl);
      el.remove();
      return _this;
    });
    _defineProperty(this, "reRender", function (cart) {
      var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var el = _this.rootEl;
      _this.init(cart, show).render(el);
      return _this;
    });
    _defineProperty(this, "getSaving", () => {
      var _this$cart;
      return (_this$cart = this.cart) === null || _this$cart === void 0 || (_this$cart = _this$cart.items) === null || _this$cart === void 0 ? void 0 : _this$cart.reduce((acc, item) => {
        if (item.compare_at_price && item.compare_at_price > item.price) acc += (+item.compare_at_price - +item.price) * item.quantity;
        return acc;
      }, 0);
    });
    _defineProperty(this, "template", () => {
      var _this$cart2, _this$cart3;
      return (_this$cart2 = this.cart) !== null && _this$cart2 !== void 0 && (_this$cart2 = _this$cart2.items) !== null && _this$cart2 !== void 0 && _this$cart2.length && this.show ? "\n       <div class=\"els-cart-preview__subtotal\">\n        ".concat(this.getSaving() > 0 ? "\n          <div class=\"els-cart-preview__subtotal-item\">\n            <p class=\"els-cart-preview-saving-text\">Savings</p>\n            <p class=\"els-cart-preview-saving-text\" data-cart-subtotal>\u2013".concat((0,_libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(this.getSaving(), _src_Helper__WEBPACK_IMPORTED_MODULE_1__.Helper.MONEY_FORMAT), "</p>\n          </div>\n        ") : '', "\n        <div class=\"els-cart-preview__subtotal-item\">\n          <p>Subtotal</p>\n          <p data-cart-subtotal>").concat((0,_libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__.formatMoney)((_this$cart3 = this.cart) === null || _this$cart3 === void 0 ? void 0 : _this$cart3.total_price, _src_Helper__WEBPACK_IMPORTED_MODULE_1__.Helper.MONEY_FORMAT), "</p>\n        </div>\n      </div>\n    ") : '<div data-cart-subtotal></div>';
    });
  }
  init(cart) {
    var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    this.cart = cart;
    this.show = show;
    this.rootEl = (0,_libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__.htmlToElement)(this.template());
    return this;
  }
}

/***/ }),

/***/ "./components/CartTitle.ts":
/*!*********************************!*\
  !*** ./components/CartTitle.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CartTitle)
/* harmony export */ });
/* harmony import */ var _libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../libs/utilites.js */ "./libs/utilites.js");
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// @ts-ignore

class CartTitle {
  constructor() {
    var _this = this;
    // @ts-ignore
    // @ts-ignore
    _defineProperty(this, "isShowing", true);
    _defineProperty(this, "render", function (el) {
      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'afterend';
      //@ts-ignore
      el.insertAdjacentElement(position, _this.rootEl);
      el === null || el === void 0 || el.remove();
      return _this;
    });
    _defineProperty(this, "reRender", isShowing => {
      this.isShowing = isShowing;
      var el = this.rootEl;
      this.rootEl = (0,_libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__.htmlToElement)(this.template());
      this.render(el);
    });
    _defineProperty(this, "template", () => {
      return this.isShowing ? "<div class=\"els-cart-preview__title\">\n        <p>Your Cart</p>\n    <div>" : '<div data-cart-title></div>';
    });
  }
  init() {
    this.rootEl = (0,_libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__.htmlToElement)(this.template());
    return this;
  }
}

/***/ }),

/***/ "./components/CartUpselItem.ts":
/*!*************************************!*\
  !*** ./components/CartUpselItem.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CartUpsellItem)
/* harmony export */ });
/* harmony import */ var _libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../libs/utilites.js */ "./libs/utilites.js");
/* harmony import */ var _src_Helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../src/Helper */ "./src/Helper.ts");
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// @ts-ignore


class CartUpsellItem {
  constructor() {
    var _this = this;
    //@ts-ignore
    _defineProperty(this, "isView", false);
    _defineProperty(this, "render", function (el) {
      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'beforeend';
      if (!el) return _this;
      //@ts-ignore
      el.insertAdjacentElement(position, _this.rootEl);
      return _this;
    });
    _defineProperty(this, "addEventListeners", () => {
      var _this$addBtn;
      //@ts-ignore
      (_this$addBtn = this.addBtn) === null || _this$addBtn === void 0 || _this$addBtn.addEventListener('click', () => this.onAdd(this.variant.id));
    });
    _defineProperty(this, "template", () => {
      return "\n      <div class=\"els-cart-preview__upsell\">\n        ".concat(!!this.variant.compare_at_price && this.variant.compare_at_price > this.variant.price ? '<div class="els-cart-preview__upsell-badge sale-badge">Sale</div>' : '', "\n        <div class=\"els-cart-preview__upsell-image\">\n          <img src=\"").concat(this.item.featured_image, "\">\n        </div>\n        <div class=\"els-cart-preview__upsell-content\">\n          <a href=\"/products/").concat(this.item.handle, "\" class=\"els-cart-preview__upsell-title\">").concat(this.item.title, "</a>\n          <div class=\"els-cart-preview__upsell-price-box\">\n            <div class=\"els-cart-preview-price\">\n              ").concat(!!this.variant.compare_at_price || this.item.isGift ? "<p class=\"els-cart-preview-price__old-price\">".concat((0,_libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(this.item.isGift && !this.variant.compare_at_price ? this.variant.price : this.variant.compare_at_price, _src_Helper__WEBPACK_IMPORTED_MODULE_1__.Helper.MONEY_FORMAT), "</p>") : '', "\n              <p class=\"els-cart-preview-price__price\">").concat(this.variant.price > 0 && !this.item.isGift ? (0,_libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(this.variant.price, _src_Helper__WEBPACK_IMPORTED_MODULE_1__.Helper.MONEY_FORMAT) : 'Free', "</p>\n            </div>\n            ").concat(!!this.item.isAdded ? "<p class=\"els-cart-preview__upsell-added-text\">Item Added!</p>" : this.isView ? "<a href=\"/products/".concat(this.item.handle, "\" class=\"els-cart-preview__upsell-btn\">View</a>") : '<button class="els-cart-preview__upsell-btn" data-add-btn>Add</button>', "\n          </div>\n          </div>\n        </div>\n      </div>\n    ");
    });
  }
  //@ts-ignore

  //@ts-ignore

  //@ts-ignore

  init(item, onAdd) {
    var isView = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    this.isView = isView;
    this.item = item;
    this.variant = item === null || item === void 0 ? void 0 : item.variants[0];
    this.onAdd = onAdd;
    this.rootEl = (0,_libs_utilites_js__WEBPACK_IMPORTED_MODULE_0__.htmlToElement)(this.template());
    //@ts-ignore
    this.addBtn = this.rootEl.querySelector('[data-add-btn]');
    this.addEventListeners();
    return this;
  }
}

/***/ }),

/***/ "./libs/Cart.ts":
/*!**********************!*\
  !*** ./libs/Cart.ts ***!
  \**********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Cart)
/* harmony export */ });
class Cart {
  /**
   *
   * @returns {Promise<any>}
   */
  get() {
    return new Promise(resolve => {
      return resolve(this.queryToCart('/cart?view=els-cart-preview'));
    });
  }
  update(updates) {
    return new Promise(resolve => {
      //@ts-ignore
      return resolve(this.queryToCart('/cart/update.js', {
        updates
      }, 'POST'));
    });
  }
  itemAdd(item) {
    return new Promise(resolve => {
      //@ts-ignore
      return resolve(this.queryToCart('/cart/add.js', {
        items: [item]
      }, 'POST'));
    });
  }
  itemUpdateQty(key, qty) {
    return new Promise(resolve => {
      var updates = {};
      //@ts-ignore
      updates[key] = qty;
      return resolve(this.update(updates));
    });
  }
  itemRemove(key) {
    return this.itemUpdateQty(key, 0);
  }
  /**
   *
   * @returns {Promise<*>}
   */
  getItems() {
    return new Promise(resolve => {
      var _cart$items;
      var cart = this.get();
      //@ts-ignore
      return resolve((_cart$items = cart === null || cart === void 0 ? void 0 : cart.items) !== null && _cart$items !== void 0 ? _cart$items : []);
    });
  }
  /**
   *
   * @param key
   * @returns {Promise<*|null>}
   */
  getAttribute(key) {
    return new Promise(resolve => {
      return this.get().then(cart => {
        var _cart$attributes$key;
        // @ts-ignore
        return resolve(key && !!(cart !== null && cart !== void 0 && cart.attributes) ? (_cart$attributes$key = cart.attributes[key]) !== null && _cart$attributes$key !== void 0 ? _cart$attributes$key : null : null);
      });
    });
  }
  /**
   *
   * @param attributes
   * @returns {Promise<any>}
   */
  setAttribute(attributes) {
    // @ts-ignore
    return new Promise(resolve => this.queryToCart('/cart/update.js', {
      attributes
    }, 'POST').then(data => resolve(data)));
  }
  /**
   *
   * @param key
   * @returns {Promise<*>}
   */
  removeAttribute(key) {
    return new Promise(resolve => resolve(this.setAttribute({
      [key]: null
    })));
  }
  /**
   *
   * @param url
   * @param body
   * @param method
   * @returns {Promise<any>}
   */
  queryToCart(url) {
    var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
    return new Promise(resolve => {
      var params = {
        method
      };
      if (method === 'POST') {
        //@ts-ignore
        params.headers = {
          "Content-Type": "application/json"
        };
        //@ts-ignore
        params.body = JSON.stringify(body);
      }
      var response = new Promise(resolve => resolve(fetch(url, params)));
      return resolve(response.then(r => r.json()));
    });
  }
}

/***/ }),

/***/ "./pages/ProductPage.ts":
/*!******************************!*\
  !*** ./pages/ProductPage.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ProductPage)
/* harmony export */ });
/* harmony import */ var _libs_Cart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../libs/Cart */ "./libs/Cart.ts");
/* harmony import */ var _src_Helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../src/Helper */ "./src/Helper.ts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }


class ProductPage {
  //@ts-ignore

  //@ts-ignore

  init(cartPreview) {
    this.cartPreview = cartPreview;
    this.cart = new _libs_Cart__WEBPACK_IMPORTED_MODULE_0__["default"]();
    this.addEventListeners();
  }
  addEventListeners() {
    var btn = document.querySelector(_src_Helper__WEBPACK_IMPORTED_MODULE_1__.Helper.ADD_TO_CART_BTN_SELECTOR);
    if (btn) {
      btn.addEventListener('click', e => {
        var variantIdInput = document.querySelector(_src_Helper__WEBPACK_IMPORTED_MODULE_1__.Helper.PDP_VARIANT_ID_INPUT_SELECTOR);
        var qtyInput = document.querySelector(_src_Helper__WEBPACK_IMPORTED_MODULE_1__.Helper.PDP_QTY_INPUT_SELECTOR);
        var sellingPlanInput = document.querySelector(_src_Helper__WEBPACK_IMPORTED_MODULE_1__.Helper.PDP_SELLING_PLAN_INPUT_SELECTOR);
        if (variantIdInput) {
          var _this$cart;
          e.preventDefault();
          //@ts-ignore
          (_this$cart = this.cart) === null || _this$cart === void 0 || _this$cart.itemAdd(_objectSpread({
            //@ts-ignore
            id: +variantIdInput.value,
            //@ts-ignore
            quantity: +(qtyInput === null || qtyInput === void 0 ? void 0 : qtyInput.value) || 1
          }, +(sellingPlanInput === null || sellingPlanInput === void 0 ? void 0 : sellingPlanInput.value) ? {
            selling_plan: +(sellingPlanInput === null || sellingPlanInput === void 0 ? void 0 : sellingPlanInput.value)
          } : {})).then(() => {
            var _this$cartPreview;
            (_this$cartPreview = this.cartPreview) === null || _this$cartPreview === void 0 || _this$cartPreview.openAndProductAdded();
          });
        }
      });
    }
  }
}

/***/ }),

/***/ "./src/Helper.ts":
/*!***********************!*\
  !*** ./src/Helper.ts ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Helper: () => (/* binding */ Helper)
/* harmony export */ });
/* harmony import */ var _types_PagesEnum__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./types/PagesEnum */ "./src/types/PagesEnum.ts");
var _class;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

class Helper {}
_class = Helper;
_defineProperty(Helper, "DATA", window['ELS_CART_PREVIEW_DATA']);
_defineProperty(Helper, "IS_CART_PAGE", _class.DATA.page === _types_PagesEnum__WEBPACK_IMPORTED_MODULE_0__.PagesEnum.CART);
_defineProperty(Helper, "IS_PRODUCT_PAGE", _class.DATA.page === _types_PagesEnum__WEBPACK_IMPORTED_MODULE_0__.PagesEnum.PRODUCT);
_defineProperty(Helper, "MONEY_FORMAT", _class.DATA.moneyFormat);
_defineProperty(Helper, "RECOMMENDED_ITEMS", _class.DATA.recommendedItems);
_defineProperty(Helper, "GIFTS", _class.DATA.gifts);
_defineProperty(Helper, "CART_TOTAL_PRICE_FOR_GIFTS", _class.DATA.cartTotalPriceForGifts);
_defineProperty(Helper, "BANNER_TEXT", _class.DATA.bannerText);
_defineProperty(Helper, "CART_PREVIEW_LINK_BUTTON", _class.DATA.cartPreviewLinkButton);
_defineProperty(Helper, "FREE_GIFT_PROGRESS_BAR_TEXT", _class.DATA.freeGiftProgressBarText);
_defineProperty(Helper, "PRODUCT", _class.DATA.product);
_defineProperty(Helper, "PRODUCT_UPSELLS", _class.DATA.productUpsells);
_defineProperty(Helper, "CART_SHOW_BUTTONS_SELECTOR", 'form[action*="/cart/add"] [type="submit"], [els-cart-preview-show]');
_defineProperty(Helper, "ADD_TO_CART_BTN_SELECTOR", 'form[action*="/cart/add"] [type="submit"]');
_defineProperty(Helper, "PDP_QTY_INPUT_SELECTOR", 'form[action*="/cart/add"] .js-qty input');
_defineProperty(Helper, "PDP_SELLING_PLAN_INPUT_SELECTOR", 'form[action*="/cart/add"] [name="selling_plan"]');
_defineProperty(Helper, "PDP_VARIANT_ID_INPUT_SELECTOR", 'form[action*="/cart/add"] [name="id"]');

/***/ }),

/***/ "./src/types/PagesEnum.ts":
/*!********************************!*\
  !*** ./src/types/PagesEnum.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PagesEnum: () => (/* binding */ PagesEnum)
/* harmony export */ });
var PagesEnum;
(function (PagesEnum) {
  PagesEnum["PRODUCT"] = "product";
  PagesEnum["CART"] = "cart";
  PagesEnum["OTHER"] = "other";
})(PagesEnum || (PagesEnum = {}));

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
/*!******************!*\
  !*** ./index.ts ***!
  \******************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _src_Helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./src/Helper */ "./src/Helper.ts");
/* harmony import */ var _components_CartPreview__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components/CartPreview */ "./components/CartPreview.ts");
/* harmony import */ var _pages_ProductPage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./pages/ProductPage */ "./pages/ProductPage.ts");



if (!_src_Helper__WEBPACK_IMPORTED_MODULE_0__.Helper.IS_CART_PAGE) {
  //@ts-ignore
  new _components_CartPreview__WEBPACK_IMPORTED_MODULE_1__["default"]().init().then(cartPreview => {
    cartPreview.render();
    if (_src_Helper__WEBPACK_IMPORTED_MODULE_0__.Helper.IS_PRODUCT_PAGE) {
      new _pages_ProductPage__WEBPACK_IMPORTED_MODULE_2__["default"]().init(cartPreview);
    }
  });
}
})();

/******/ })()
;